import { Static, Type } from "@sinclair/typebox";
import { User } from "@whatslly/types/User";

export const ApiErrorResponse = Type.Object({
  error: Type.String(),
  data: Type.Optional(Type.Array(Type.String())),
  success: Type.Literal(false),
  errorCode: Type.Optional(Type.String()),
  user: Type.Optional(User),
});

export type ApiErrorResponseType = Static<typeof ApiErrorResponse>;
